module.exports = __webpack_public_path__ + "img/reschedule.06bc3d5a.svg";